export const getPropertyValue = ({ varName, elementScope, fallback }) => {
  elementScope = elementScope ?? document.documentElement;

  if (typeof elementScope === "string") {
    elementScope = document.querySelector(elementScope);
  }

  if (!elementScope) return fallback;

  return getComputedStyle(elementScope).getPropertyValue(varName);
};

export const execNumber = (string) => {
  if (typeof string === "string") {
    return +string.match(/\d+/g)?.[0];
  }

  return null;
};
